import fakeDrupal from './slice';
import common from './behaviors/common';
import SelectPicker from './behaviors/selectPicker';
import exampleSlider from './behaviors/exampleSlider';
import QuartalSlider from './behaviors/quartal-slider';
import ProductPhoto from './behaviors/product-photo';
import PromoGroupTable from './behaviors/promo-group-table';
import SwitchBig from './behaviors/switch-big';
import PromoDates from './behaviors/promo-dates';
import CollapsePanel from './behaviors/collapse-panel';
import CustomTable from './behaviors/data-table';
import PlanningCommunications from './behaviors/planning-communication';
// Emulate Drupal:
fakeDrupal();

// Create behaviors:
common();
SelectPicker();
exampleSlider();
ProductPhoto();
QuartalSlider();
PromoGroupTable();
SwitchBig();
PromoDates();
CollapsePanel();
CustomTable();
PlanningCommunications();



// WEBPACK FOOTER //
// ./js/src/main.js